import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiPaper from '@material-ui/core/Paper';
import { combineClasses, styled, useThemeProps, } from '../../foundation';
import { PaperStyle } from './styles';
import { RcPaperClasses } from './utils';
var _RcPaper = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcPaper' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcPaperClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiPaper, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcPaper = styled(_RcPaper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), PaperStyle);
RcPaper.defaultProps = {};
RcPaper.displayName = 'RcPaper';
export { RcPaper };
var templateObject_1;
